import { ensureExhaustive, exhaustiveReducer } from "halifax";
import { Initial, PremiumOffersFilterType } from "redmond";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import {
  CONTROL,
  FTCPricingUpdateVariantType,
} from "../../../context/experiments";
import { actions } from "../actions";
import {
  FETCH_PREMIUM_OFFERS_SHOP,
  SET_FILTER_CATEGORY_VALUE,
  SET_FTC_PRICING_UPDATE_VARIANT,
  SET_IS_USER_TRIGGERED_SEARCH,
  SET_OFFERS_SORT,
  SET_PREMIUM_OFFERS_SHOP_RESULTS,
} from "../actions/constants";
import { RequestState, RequestStateUtils } from "./requestState";

export * from "./requestState";

export interface IRooms {
  numberOfRooms: number;
}

// Sort options constants
export const SORT_OPTIONS = {
  RECOMMENDED: "recommended",
  PRICE_ASC: "price-asc",
  PRICE_DESC: "price-desc",
} as const;

export type SortOption = (typeof SORT_OPTIONS)[keyof typeof SORT_OPTIONS];

export interface IPremiumCollectionOffersSearchState {
  premiumOffersShopCall: RequestState<
    IOfferAvailabilityRequest,
    Initial,
    Error
  >;
  sort: SortOption;
  isUserTriggeredSearch: boolean;
  selectedFilterCategory: PremiumOffersFilterType;
  ftcPricingUpdateVariant: FTCPricingUpdateVariantType;
}

const initialState: IPremiumCollectionOffersSearchState = {
  premiumOffersShopCall: RequestStateUtils.notCalled(),
  sort: SORT_OPTIONS.RECOMMENDED,
  isUserTriggeredSearch: false,
  selectedFilterCategory: PremiumOffersFilterType.ALL,
  ftcPricingUpdateVariant: CONTROL,
};

export const reducer = exhaustiveReducer(
  initialState,
  (
    state: IPremiumCollectionOffersSearchState,
    action: actions.PremiumCollectionOffersSearchActions
  ): IPremiumCollectionOffersSearchState => {
    switch (action.type) {
      case FETCH_PREMIUM_OFFERS_SHOP:
        return {
          ...state,
          premiumOffersShopCall: RequestStateUtils.inProgress(action.params),
        };
      case SET_PREMIUM_OFFERS_SHOP_RESULTS:
        return {
          ...state,
          premiumOffersShopCall: action.payload,
        };
      case SET_OFFERS_SORT:
        return {
          ...state,
          sort: action.sort,
        };
      case SET_IS_USER_TRIGGERED_SEARCH:
        return {
          ...state,
          isUserTriggeredSearch: action.isUserTriggeredSearch,
        };
      case SET_FILTER_CATEGORY_VALUE:
        return {
          ...state,
          selectedFilterCategory: action.selectedFilterCategory,
        };
      case SET_FTC_PRICING_UPDATE_VARIANT:
        return {
          ...state,
          ftcPricingUpdateVariant: action.variant,
        };
      default:
        return ensureExhaustive(action);
    }
  }
);
